<template>
  <div class="task">
    <ul class="pub_nav">
      <li class="active">
        <a href="javascript:;">我的任务</a>
      </li>
    </ul>

    <div class="pub_content" v-if="designer_list.length">
      <div class="box">
        <div class="box_title">
          <div class="box_title_left">全部任务</div>
          <div class="box_title_right">
            <el-select v-model="params.assign_status" placeholder="请选择" class="active" @change="search">
              <el-option key="-1" label="全部状态" value=""></el-option>
              <el-option
                v-for="item in status"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="box_content">
          <!-- 表格数据 -->
          <myTable :tableObj="tableObj" @changePageNo="getList"></myTable>
        </div>
      </div>
    </div>
    <div class="btn" v-else>
      <span>你还不是设计师</span>
      <el-button @click="enter">去入驻</el-button>
    </div>
  </div>
</template>

<script>
import myTable from "@/components/my_table";
import { format } from 'url';
export default {
  components: {
    myTable
  },
  data() {
    return {
      designer_list:[],
      tableObj: {
        list: [
        ], //列表数据
        btns: [
          //按钮组
          //   {
          //     name: "删除",
          //     funcName: "deleteCourse"
          //   }
        ],
        table_detail: [
          //table详情
          {
            prop: "",
            label: "任务信息",
            width: "300px",
            formatter: row => {
              return `
              <div class="video_info">
                <div class="video_left">
                  <img src=${row.assign_coverPath} alt />
                </div>
                <div class="video_right">
                  <a href="#/task_hall_detail?id=${row.assign_id}">
                    <p class="video_title">${row.assign_name}</p>
                  </a>
                  <p class="video_time">${row.assign_createt_date.split(" ")[0]}</p>
                </div>
              </div>`;
            }
          },
          {
            prop:"",
            label:"查看作品",
            formatter:row => {
              return `<div>
                <a href="#/task_hall_opus_detail?id=${row.assign_id}">
                  <p class="opus_name">${row.name}</p>
                </a>
              </div>`
            }
          },
          {
            prop: "assign_end_collect_date",
            label: "截止时间",
            width:"105px",
            formatter:(row) => {
              return row.assign_end_collect_date.split(" ")[0]
            }
          },
          {
            prop: "assign_status_name",
            label: "任务状态",
            width:"105px"
          },
          {
            prop: "status_name",
            label: "状态"
          },
          {
            prop: "assign_submit_count",
            label: "参与人数"
          }
        ],
        layerpageinfo: {
          //分页
          pageNo: 0,
          total: 0,
          pageSize: 6
        }
      },
      status: [
        { name:'征集中', code:'AssignStatusCollection' },
        { name:'征集结束', code:'AssignStatusCollectionEnd' },
        { name:'筛选中', code:'AssignStatusScreen' },
        { name:'生产中', code:'AssignStatusProduction' },
        { name:'销售中', code:'AssignStatusSale' },
      ],
      params: {
        active: '',
        name: '',
        type: '',
        assign_status: ''
      },
      identityId:'',   //设计师身份
    };
  },
  created(){
    if (this.$store.state.info) {
      this.initInfo(); /** 查询认证 用于二次编辑*/
    } else {
      this.needInfo("initInfo");
    }
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  methods: {
    // 获取列表
    getList() {
      let obj = {
        designer_id:this.identityId,
        ...this.tableObj.layerpageinfo,
        ...this.params
      }
      this.api.getAssignSubmits(obj)
      .then(res => {
        if(res.error.err_code !== 0) return;
        let list = res.obj.list;
        this.tableObj.list = list.length ? list : [];
        this.tableObj.layerpageinfo.total = res.obj.totalSize;  
      })
    },
    search() {
      this.tableObj.layerpageinfo.pageNo = 0;
      this.getList();
    },
    // 查询已报名作品
    // getAssignSubmits(){
    //     this.api.getAssignSubmits({
    //         user_id:this.identityId
    //     })
    //     .then(res => {
    //         if(res.error.err_code !== 0) return;
    //         let list = res.obj.list;
    //     })
    // },
    // 获取是否设计师身份
    getFrontDesigners(){
        this.api.getFrontDesigners({
            user_id:this.$store.state.info.id
        })
        .then(res => {
            if(res.error.err_code !== 0) return;
            this.designer_list = res.obj.list;
            this.identityId = this.designer_list.length ? res.obj.list[0].id : '';
            this.getList()
        })
    },
    // 入驻设计师
    enter(){
      this.$router.push({
          name:'join'
      })
    },
    // 监听个人信息
    needInfo(name) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          this[name]();
          watchAch(); //取消监听
        }
      });
    },
    initInfo(){
      // 获取设计师
      this.getFrontDesigners()
    }
  }
};
</script>

<style lang="scss">
@import "../index.scss";
.task {
  .pub_content {
    .box {
      .box_content {
        .el-table th{
          background-color: #f8f8f8;
        }
        .video_info {
          width: 480px;
          display: flex;
          // justify-content: space-between;
          .video_left {
            margin-right: 20px;
            img {
              width: 128px;
              height: 72px;
            }
          }
          .video_right {
            display: flex;
            height: 72px;
            flex-direction: column;
            justify-content: space-between;
            padding: 5px 0;
            box-sizing: border-box;
            .video_title {
              font-size: 14px;
              line-height: 24px;
              color: #333;
              max-width: 325px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              text-align: left;
            }
            .video_title:hover{
              color: #117EFF;
              cursor: pointer;
            }
            .video_time {
              font-size: 12px;
              color: #999;
              line-height: 22px;
              text-align: left;
            }
            
          }
        }
        a{
          color: #333;
          .opus_name:hover{
            color: #117EFF;
            cursor: pointer;
          }
        }
      }
    }
  }
  .btn{
      padding: 20px;
      .el-button{
        background-color: #333;
        border-color: #333;
        color: white;
        margin-left: 15px;
      }
  }
}
</style>